import React, { useRef } from "react";

const useFullscreen = (callback: (isFull: boolean) => void) => {
  const element = useRef<HTMLDivElement>();
  const runCb = (isFull: boolean) => {
    if (callback && typeof callback === "function") {
      callback(isFull);
    }
  };
  const triggerFull = () => {
    if (element.current && element.current.requestFullscreen) {
      element.current.requestFullscreen();
      runCb(true);
    }
  };

  const exitFull = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
    runCb(false);
  };
  return { element, triggerFull, exitFull };
};

export default useFullscreen;
